import React, { useMemo } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';
import { Calendar } from 'react-native-calendars';
import { allStyles } from './FormStyles';
import TitleLabel from './TitleLabel';
import { DATE_FORMAT, getCalendarDateMeta } from '../../utils/CalendarUtils';

const styles = StyleSheet.create(allStyles);

export default function FieldCalendar(props) {
    const { date={} } = props;

    const meta = useMemo(() => {
        const { today, startDate, endDate, availableWeekdays } = getCalendarDateMeta(date);

        // disable today if after startDate / not in availableWeekdays

        const disabled = { disabled: true, disableTouchEvent: true };

        const disabledToday = (today.isSameOrAfter(startDate) && availableWeekdays.includes(today.day())) ? {} : {[today.format(DATE_FORMAT)]: disabled};

        // disable other days if not in availableWeekdays

        let pivot = startDate.clone();
        let end = endDate.clone();

        let disabledDays = {};

        while(pivot.isSameOrBefore(end)) {
            if (!availableWeekdays.includes(pivot.day())) {
                disabledDays[pivot.format(DATE_FORMAT)] = disabled;
            }
            pivot.add(1, 'day');
        }

        return {
            startDate,
            endDate,
            disabledToday,
            disabledDays,
        };
    }, [date]);

    const markedDates = useMemo(() => {
        let selectedDate = {};

        if (props.value) {
            selectedDate[props.value] = {
                selected: true,
                selectedColor: '#212121'
            };
        }

        return {...selectedDate, ...meta.disabledToday, ...meta.disabledDays}
    }, [props.value, meta])

    return (
        <View style={[styles.fieldContainer, props.containerStyle]}>
            <TitleLabel {...props}/>
            <View style={{marginTop:10, borderColor:'#D0D0D0', borderWidth:StyleSheet.hairlineWidth, borderRadius:20, padding:20}}>
                <Calendar
                    theme={{
                        textColor:'#212121',
                        indicatorColor:'#212121',
                        arrowColor:'#212121',
                        todayTextColor:'#212121',
                        dayTextColor: '#212121',
                        monthTextColor: '#212121',
                    }}
                    onDayPress={(day) => {
                        props.onChange({
                            name: props.name,
                            value: day.dateString,
                        })
                    }}
                    minDate={meta.startDate.format(DATE_FORMAT)}
                    maxDate={meta.endDate.format(DATE_FORMAT)}
                    markedDates={markedDates}
                    initialDate={meta.startDate.format(DATE_FORMAT)}
                    renderArrow={(direction) => {
                        if (direction == 'left') {
                            return (
                                <Image style={{
                                    width: 15,
                                    height: 15,
                                    resizeMode:'contain',
                                    transform: [{ rotateZ: '90deg' }]
                                }} source={require('../../assets/arrow_down.png')}/>
                            )
                        } else {
                            return (
                                <Image style={{
                                    width: 15,
                                    height: 15,
                                    resizeMode:'contain',
                                    transform: [{ rotateZ: '-90deg' }]
                                }} source={require('../../assets/arrow_down.png')}/>
                            )
                        }
                    }}
                />
            </View>
        </View>
    )
}